import React from 'react'
import PropTypes from 'prop-types'
import ErrorBoundary from '../../../../../molecules/ErrorBoundary'
import FadeIn from '../../../../../molecules/Transitions/FadeIn'
import { AccountContentManagementView } from './AccountContentManagementView'

const ContentThingsTool = ({ accountId }) => {
  return (
    <ErrorBoundary name='Account Content Tab'>
      <FadeIn>
        <AccountContentManagementView accountId={accountId} />
      </FadeIn>
    </ErrorBoundary>
  )
}

ContentThingsTool.propTypes = {
  accountId: PropTypes.number
}

export default ContentThingsTool
